import { __assign, __extends, __spreadArray } from "tslib";
import React, { PureComponent } from "react";
import { render } from "react-dom";
import { Dialog, DialogContent, DialogActions, Button, makeStyles, createStyles, ThemeProvider, Typography } from "@material-ui/core";
import globalTheme from "../theme";
var useStyles = makeStyles(function (theme) {
  return createStyles({
    content: {
      minWidth: "300px",
      paddingTop: 16,
      paddingBottom: 16
    },
    title: {
      fontSize: 20,
      lineHeight: "1.6em",
      color: "rgba(0,0,0,0.87)",
      marginBottom: 10
    },
    description: {
      fontSize: 16,
      lineHeight: "1.5em",
      color: "rgba(0,0,0,0.54)"
    },
    noBorder: {
      border: "none !important"
    },
    cancelButton: {
      color: "rgba(0,0,0,0.54)",
      textTransform: "capitalize"
    },
    okButton: {
      textTransform: "capitalize"
    }
  });
});

var Confirm = function Confirm(_a) {
  var open = _a.open,
      title = _a.title,
      content = _a.content,
      okText = _a.okText,
      showCancel = _a.showCancel,
      cancelText = _a.cancelText,
      onOk = _a.onOk,
      onCancel = _a.onCancel;
  var classes = useStyles();
  return React.createElement(Dialog, {
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    open: open
  }, React.createElement(DialogContent, {
    className: classes.content
  }, title && React.createElement(Typography, {
    component: "h2",
    className: classes.title
  }, title), React.createElement(Typography, {
    className: classes.description
  }, content)), React.createElement(DialogActions, {
    className: classes.noBorder
  }, showCancel && React.createElement(Button, {
    autoFocus: true,
    onClick: onCancel,
    className: classes.cancelButton
  }, cancelText ? cancelText : "Cancel"), React.createElement(Button, {
    onClick: onOk,
    color: "primary",
    className: classes.okButton
  }, okText ? okText : "Ok")));
};

var ConfirmContainer =
/** @class */
function (_super) {
  __extends(ConfirmContainer, _super);

  function ConfirmContainer(props) {
    var _this = _super.call(this, props) || this;

    _this._handleOk = function (confirmData) {
      confirmData.onOk && confirmData.onOk();

      _this._removeConfirm(confirmData.id);
    };

    _this._handleCancel = function (confirmData) {
      confirmData.onCancel && confirmData.onCancel();

      _this._removeConfirm(confirmData.id);
    };

    _this.confirm = function (data) {
      var id = "".concat(Math.random());

      var confirmData = __assign({
        id: id,
        open: true,
        showCancel: true
      }, data);

      _this._addConfirm(confirmData);

      var close = _this._removeConfirm.bind(_this, id);

      return close;
    };

    _this.alert = function (data) {
      var id = "".concat(Math.random());

      var confirmData = __assign(__assign({
        id: id,
        open: true
      }, data), {
        showCancel: false
      });

      _this._addConfirm(confirmData);

      var close = _this._removeConfirm.bind(_this, id);

      return close;
    };

    _this.state = {
      data: []
    };
    return _this;
  }

  ConfirmContainer.prototype._removeConfirm = function (id) {
    this.setState(function (state) {
      return {
        data: state.data.filter(function (v) {
          return v.id !== id;
        })
      };
    });
  };

  ConfirmContainer.prototype._addConfirm = function (confirmData) {
    this.setState(function (state) {
      state.data.push(confirmData);
      return {
        data: __spreadArray([], state.data, true)
      };
    });
  };

  ConfirmContainer.prototype.render = function () {
    var _this = this;

    var data = this.state.data;
    return React.createElement(ThemeProvider, {
      theme: globalTheme
    }, React.createElement("div", null, data.map(function (v) {
      return React.createElement(Confirm, {
        key: v.id,
        open: v.open,
        title: v.title,
        content: v.content,
        okText: v.okText,
        showCancel: v.showCancel,
        cancelText: v.cancelText,
        onOk: function onOk() {
          _this._handleOk(v);
        },
        onCancel: function onCancel() {
          _this._handleCancel(v);
        }
      });
    })));
  };

  return ConfirmContainer;
}(PureComponent);

var confirmInstance;

function init() {
  if (confirmInstance) {
    return confirmInstance;
  }

  var component = React.createElement(ConfirmContainer, null);
  var container = document.createElement("div");
  document.body.appendChild(container);
  var newConfirmInstance = render(component, container);
  confirmInstance = newConfirmInstance;
  return confirmInstance;
}

export default {
  confirm: function confirm(confirmData) {
    var confirm = init();
    return confirm.confirm(confirmData);
  },
  alert: function alert(confirmData) {
    var confirm = init();
    return confirm.alert(confirmData);
  }
};